import React from 'react';
import { FileText, Download, Star } from 'lucide-react';
import { Button } from '../ui/button';

const PopularTemplates = () => {
  const templates = [
    {
      category: 'Training',
      title: 'Sales Onboarding - 30/60/90 Day Plan',
      description: 'Complete onboarding curriculum for new sales reps with milestones, training modules, and success metrics',
      rating: 4.9,
      downloads: '2.3k'
    },
    {
      category: 'Roleplay',
      title: 'Objection Handling Practice Scenarios',
      description: '15 common sales objections with AI coaching feedback and winning response frameworks',
      rating: 4.8,
      downloads: '1.8k'
    },
    {
      category: 'Training',
      title: 'Customer Support Training Program',
      description: 'Week-by-week training plan covering product knowledge, soft skills, and escalation procedures',
      rating: 4.9,
      downloads: '2.1k'
    },
    {
      category: 'Roleplay',
      title: 'Discovery Call Roleplay Guide',
      description: 'Practice scenarios for conducting effective discovery calls with qualifying questions and talk tracks',
      rating: 4.8,
      downloads: '1.9k'
    },
    {
      category: 'Training',
      title: 'Leadership Development Program',
      description: 'Comprehensive leadership training covering communication, coaching, and team management',
      rating: 4.7,
      downloads: '1.6k'
    },
    {
      category: 'Roleplay',
      title: 'Customer De-escalation Scenarios',
      description: 'Practice handling difficult customer situations with AI-powered feedback and scoring',
      rating: 4.8,
      downloads: '1.5k'
    }
  ];

  const categoryColors = {
    Training: 'bg-blue-900/30 text-blue-400 border-blue-700',
    Roleplay: 'bg-indigo-900/30 text-indigo-400 border-indigo-700'
  };

  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Most Popular Templates</h2>
          <p className="text-xl text-gray-400">Get started with these top-rated templates from the Traain community</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {templates.map((template, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-xl p-6 border border-gray-700 hover:border-gray-600 transition-all group"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className={`px-3 py-1 rounded-lg text-xs font-semibold border ${categoryColors[template.category]}`}>
                  {template.category}
                </span>
                <div className="flex items-center gap-1 text-yellow-400">
                  <Star className="w-4 h-4 fill-current" />
                  <span className="text-sm font-semibold">{template.rating}</span>
                </div>
              </div>

              <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">
                {template.title}
              </h3>
              
              <p className="text-gray-400 text-sm mb-4">
                {template.description}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-gray-700">
                <div className="flex items-center gap-2 text-gray-400 text-sm">
                  <Download className="w-4 h-4" />
                  <span>{template.downloads} uses</span>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  className="border-gray-600 text-gray-300 hover:bg-gray-700"
                >
                  <FileText className="w-4 h-4 mr-2" />
                  Preview
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularTemplates;